import HeroSection from "../../Components/HeroSection/HeroSection";
import PremiumBrands from "../../Components/PremiumBrands/PremiumBrands";

import WelcomeSection from "../../Components/WelcomeSection/WelcomeSection";

const Home = () => {
  return (
    <>
      <HeroSection />
      <WelcomeSection />
      <PremiumBrands />
    </>
  );
};
export default Home;
